import React from "react";
import { Space } from "antd"

export const Conjunto: React.FC<{itens: React.ReactNode[] | undefined, style?: React.CSSProperties}> = (props) => {
    return <React.Fragment>
        <Space size="middle" style={{ ...props.style }}>
            {props.itens?.filter((i) => i != undefined && typeof(i) !== "boolean").map((v, i) => <span key={i}>{v}</span>)}
        </Space>
    </React.Fragment>
}

export default Conjunto